import { observer } from 'mobx-react';
import { CopyLinkView } from './CopyLink';
import { RecordCard } from '@project/store/shared/RecordCard';
import { getCardLink } from '../utils';

export interface CardLinkItemProps {
  card: RecordCard;
}

export const CardLinkItem = observer(({ card }: CardLinkItemProps) => {
  const { tableName, recordId } = card;
  const layerName = card.connectedLayer.layerName;

  const url = getCardLink({
    tableName,
    recordId: '' + recordId,
    layerName,
  });

  return <CopyLinkView url={url} title="Ссылка" />;
});
